<template>
  <div>
    <div style="display: flex; border: 1px solid #ccc; margin-bottom: 8px">
      <div style="margin-right: 10px">
        <img style="display: block" width="130px" :src="'https://image.tmdb.org/t/p/w200' + item.poster_path" alt="" />
      </div>
      <div style="padding: 5px">
        <b>{{ item.title || item.name }} </b>
        <span v-if="item.release_date || item.first_air_date">
          ({{ (item.release_date || item.first_air_date || '?').slice(0, 4) }})
        </span>
        <br />
        <span v-if="item.vote_average">
          {{ Math.round(item.vote_average * 10) / 10 }}<v-icon color="orange" small>mdi-star</v-icon>
        </span>
        <p>{{ item.overview.slice(0, overview_length) + '...' }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hey: null,
    }
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    overview_length: {
      type: Number,
      default: 100,
    },
  },
}
</script>

<style lang="scss" scoped></style>
